<template>
	<div class="data-table-page">
		<div class="header d-flex justify-content-between align-items-center">
			<h1>Data table</h1>
			<div class="actions"></div>
		</div>

		<div class="card">
			<div class="card-body p-3">
				<!-- Table header -->
				<div id="tableHeader" class="table-header d-flex justify-content-between align-items-center">
					<div class="actions-left"></div>
					<div class="actions-right">
						<a
							class="btn btn-outline-primary btn-sm me-1"
							data-bs-toggle="collapse"
							href="#filters"
							role="button"
							aria-expanded="false"
							aria-controls="filters"
							title="Filters"
						>
							<font-awesome-icon :icon="['fas', 'filter']" />
						</a>
						<a
							class="btn btn-outline-secondary btn-sm"
							data-bs-toggle="collapse"
							href="#visibleColumns"
							role="button"
							aria-expanded="false"
							aria-controls="visibleColumns"
							title="Column visibility settings"
						>
							<font-awesome-icon :icon="['fas', 'columns']" />
						</a>
					</div>
				</div>
				<!-- #Table header -->

				<!-- Filters -->
				<div class="collapse mb-3" id="filters">
					<p class="p-0">👋 Set filters to better search data</p>
				</div>
				<!-- #Filters -->

				<!-- Visible columns -->
				<div class="collapse mb-3" id="visibleColumns">
					<p class="p-0">👋 Select which columns to display in table</p>
					<div class="d-flex flex-wrap mb-2">
						<div :key="'column-available-' + column.name" v-for="column in columns" class="mb-2 me-1">
							<span role="button" @click="toggleVisibleColumns(column)" v-if="columnsToShow.includes(column.name)" class="badge bg-success">{{ column.name }}</span>
							<span role="button" @click="toggleVisibleColumns(column)" v-else class="badge bg-light">{{ column.name }}</span>
						</div>
					</div>
					<div class="columns-actions d-flex justify-content-between align-items-center">
						<div class="actions-left">
							<button class="btn btn-sm btn-outline-secondary" title="Configure columns">
								<font-awesome-icon :icon="['fas', 'cogs']" />
							</button>
						</div>
						<div class="actions-right"></div>
						<button class="btn btn-sm btn-outline-success float-end" title="This settings will be sawed only for you and not for your teammates">
							<font-awesome-icon :icon="['fas', 'save']" /> Save for me
						</button>
					</div>
				</div>
				<!-- #Visible columns -->

				<table class="table table-responsive-lg table-responsive-md">
					<thead>
						<tr>
							<template v-for="column in columns">
								<th :key="column.name" v-if="columnsToShow.includes(column.name)">
									{{ column.name }}
								</th>
							</template>
						</tr>
					</thead>
					<tbody>
						<tr :class="{ loading: loading }" v-for="d in data" :key="d.id">
							<template v-for="column in columns">
								<td :key="column.name + '-' + d.id" v-if="columnsToShow.includes(column.name)">
									{{ d[column.name] }}
								</td>
							</template>
						</tr>
					</tbody>
				</table>
				<!-- Pagination -->
				<div class="d-flex justify-content-between align-items-center">
					<!-- Items Statistic -->
					<div class="items-statistic">
						From
						{{ pagination.from }}
						to
						{{ pagination.to }}
						of
						{{ pagination.total }}
					</div>
					<!-- Pages navigation -->
					<div v-if="pagination.last_page > 1">
						<nav>
							<ul class="pagination" v-if="pagination.links && pagination.links.length > 0">
								<li :key="'pag-' + index" v-for="(link, index) in pagination.links" class="page-item" :class="link.active ? 'active' : ''">
									<a role="button" :disabled="true" class="page-link" @click="paginate(link.url)">{{ link.label | removeString }}</a>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import restApi from '../../api/index'
export default {
	name: 'DataTable',
	data() {
		return {
			loading: false,
			data: [],
			pagination: null,
			columns: [],
			columnsToShow: [],
			request: {
				page: this.$route.query.page | 1,
				orderBy: this.$route.query.orderBy ? this.$route.query.orderBy : 'id',
				orderDirection: this.$route.query.orderDirection ? this.$route.query.orderDirection : 'asc',
			},
		}
	},
	created() {
		this.getVisibleColumns()
		this.getTableData()
	},
	methods: {
		// Get table dataa
		getTableData() {
			this.loading = true
			restApi
				.post(this.$route.path, this.request)
				.then(({ data }) => {
					//console.log(data)
					this.data = data.data
					this.loading = false
					this.pagination = data
					this.columns = data.columns
					delete this.pagination.data
					delete this.pagination.columns
					if (!this.compareRequest()) {
						this.$router.push({ path: this.$router.currentPath, query: this.request })
					}
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: error,
						timer: 3000,
					})
				})
		},

		// Paginate - when click on paginate buttons
		paginate(url) {
			let page = 1
			page = url.split('?')[1].replace('page=', '')
			this.request.page = page
			this.getTableData()
		},

		// Compare request to avoid redirect to same page
		compareRequest() {
			let isEqual = true
			console.log(this.$route.query)
			console.log(this.request)
			for (const property in this.request) {
				if (this.$route.query[property] != this.request[property]) {
					isEqual = false
				}
			}
			return isEqual
		},

		// Visible columns
		getVisibleColumns() {
			console.log(this.$route.path)
			this.columnsToShow = ['id', 'name', 'email']
		},

		// Columns visibility settings
		toggleVisibleColumns(column) {
			if (this.columnsToShow.includes(column.name)) {
				this.columnsToShow = this.columnsToShow.filter(c => c !== column.name)
			} else {
				this.columnsToShow.push(column.name)
			}
		},
	},
	filters: {
		removeString: function(value) {
			if (!value) return ''
			value = value.replace('&laquo;', '')
			return value.replace('&raquo;', '')
		},
	},
}
</script>

<style lang="scss">
tr.loading {
	background-image: linear-gradient(to right, transparent 50%, rgba(0, 0, 0, 0.05) 50%);
	background-size: 200% 100%;
	animation: loading 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

tr.loading td {
	opacity: 0.45;
	pointer-events: none;
}

@keyframes loading {
	0% {
		background-position: 0;
	}
	50% {
		background-position: -30%;
	}
	80% {
		background-position: -100%;
	}
	100% {
		background-position: -200%;
	}
}
</style>
